// extracted by mini-css-extract-plugin
module.exports = {"pos-manual-billing-spinner":"TelecomBoard_pos-manual-billing-spinner__UjnJq","pos-manual-billing-status-text":"TelecomBoard_pos-manual-billing-status-text__NGPl2"};